import axios from 'axios';
import api from './api';

// Uploads a single image File to GCS via POST /api/uploads/image and returns
// the public URL. `folder` is an optional logical bucket prefix.
export const uploadImage = async (file, folder = 'uploads') => {
  const formData = new FormData();
  formData.append('file', file);
  const { data } = await api.post(`/uploads/image?folder=${encodeURIComponent(folder)}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data.url;
};

// Uploads a single 3D model. Two-step, direct-to-GCS so large (50–200 MB) files
// don't stream through the dyno (which would hit Heroku's 30s limit / HTTP 499):
//   1. ask our API for a short-lived signed PUT URL,
//   2. PUT the file bytes straight to Google Cloud Storage.
// Returns the upload record ({ url, filename, content_type, size }) so the
// editor can show the filename without re-parsing the URL.
// `onProgress` (0–100) is optional.
export const uploadModel = async (file, folder = 'product-3d', onProgress) => {
  const { data } = await api.post('/uploads/model-url', { filename: file.name, folder });
  // Bare axios (not the `api` instance): no Authorization header, no /api
  // baseURL — and the Content-Type MUST match what the URL was signed for.
  await axios.put(data.uploadUrl, file, {
    headers: { 'Content-Type': data.content_type },
    onUploadProgress: (e) => {
      if (onProgress && e.total) onProgress(Math.round((e.loaded / e.total) * 100));
    },
  });
  return { url: data.url, filename: data.filename, content_type: data.content_type, size: file.size };
};
